"use client";
import { HeroSection } from "./Hero";
import { FeaturesSection } from "./FeatureSection";
import { DashboardPreview } from "./DashboardPreview";
import RevealOnScroll from "@/components/ui/RevelOnScroll";
import { SEO } from "@/components/common/SEO";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "VaWeNa Platform — WealthScope & PortfolioIQ",
  "description": "WealthScope tracks net worth, buying power, and deal readiness. PortfolioIQ analyzes DSCR, cap rate, and generates Schedule E and lender reports. AI-powered real estate investment intelligence.",
  "url": "https://vawena.ai/platform",
};

export default function VaWeNaLandingPage() {
  return (
    <>
      <SEO
        title="Platform — WealthScope & PortfolioIQ for Real Estate Investors"
        description="WealthScope tracks your net worth, buying power, and deal readiness score. PortfolioIQ analyzes DSCR, cap rate, and generates Schedule E and DSCR lender reports in one click."
        canonical="/platform"
        schema={schema}
      />
      <div className="min-h-screen dark:bg-[#020D30] bg-[#f0f4ff]">
        <main>
          <HeroSection />

          <RevealOnScroll direction="up">
            <FeaturesSection />
          </RevealOnScroll>

          <RevealOnScroll direction="up">
            <DashboardPreview />
          </RevealOnScroll>
        </main>
      </div>
    </>
  );
}
